import { Box, Divider, Grid } from "@material-ui/core/";
import { useHistory } from "react-router-dom";
import { AppThemeLoggedAreationProvider } from "../../../context/ThemeLoggedAreaContext";
import TmpTypographyCustom from "../../../components/tempo/TmpTypographyCustom/TmpTypographyCustom";
import TmpButtonCollapseCustom from "../../../components/tempo/TmpButtonCollapseCustom/TmpButtonCollapseCustom";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/editar.svg";
import RequestService from "../../../services/RequestService";
import { useEffect, useState } from "react";
import TmpLoadingCustom from "../../../components/tempo/TmpLoadingCustom/TmpLoadingCustom";
import TmpAlertCustom from "../../../components/tempo/TmpAlertCustom/TmpAlertCustom";
import { useAuthContext } from "../../../context/AuthContext";
import Request from "../../../models/Request";


export default function UserHome() {

  let history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isOpenAlert, setIsOpenAlert] = useState<boolean>(false)
  const [messageAlert, setMessageAlert] = useState<string>("")
  const { logout } = useAuthContext();
  const [request, setRequests] = useState<Request[]>();
  const [firstTriggeredCall, setFirstTriggeredCall] = useState(false);
  const [showButtonCreateRequest, setShowButtonCreateRequest] = useState<boolean>(false)
  const [showButtonContinueRequest, setShowButtonContinueRequest] = useState<boolean>(false)


  //Realiza a criação de uma nova solicitação de request
  const handleCreateReRegistrationRequest = async () => {

    setIsLoading(true);

    RequestService.postReRegistrationRequestIfNotExists().then((result) => {
      history.push(`/recadastramento?requestId=${encodeURIComponent(result.encriptId)}&professionalId=${encodeURIComponent(result.professionalEncriptId)}`);
    }).catch((error: any) => {
      setIsLoading(false);
      setIsOpenAlert(true);

      if (error !== undefined && Number.parseInt(error.response.status) === 401) {
        const result = logout();

        if (result === undefined) {
          window.location.reload();
        }
      } else {
        setMessageAlert(error.response.data)
      }
    });
  }

  //Realiza a criação de uma nova solicitação de request
  const callApiFirstTime = async () => {

    setIsLoading(true);

    RequestService.getAllRequestReRegistration().then((result) => {

      setRequests(result);

      //Caso o usuário não tenha nenhuma solicitação criada, habilitar o botão para a criação de uma solicitação
      if (result.length === 0) {
        setShowButtonCreateRequest(true);
      } else {

        let existRequestInProgress = false;

        for (let index = 0; index < result.length; index++) {
          const element = result[index];

          //Se houver uma solicitação com o status = "1" (Em Preenchimento), habilitar o botão para continuara edição
          if (element.RequestState === 1) {
            setShowButtonContinueRequest(true);
            existRequestInProgress = true;
          }

          //Caso tenha alguma solicitação em Análise
          if (element.RequestStateNameToExibition !== undefined && element.RequestStateNameToExibition === "Em Análise") {
            existRequestInProgress = true;
          }

          //Caso tenha alguma solicitação em Análise, diferente de concluído, reprovado ou em preenchimento
          if (element.RequestState !== undefined && (element.RequestState !== 12 && element.RequestState !== 13 && element.RequestState !== 1)) {
            existRequestInProgress = true;
          }

        }

        //Caso não tenha nenhuma solicitação em andamento, apresentar o botão para criar uma solicitação
        if (!existRequestInProgress) {
          setShowButtonCreateRequest(true);
        }

      }

      setIsLoading(false);
      setFirstTriggeredCall(true)

    }).catch((error: any) => {
      setIsLoading(false);
      setIsOpenAlert(true);
      setFirstTriggeredCall(true)

      if (error !== undefined && error.response !== undefined && Number.parseInt(error.response.status) === 401) {
        const result = logout();

        if (result === undefined) {
          window.location.reload();
        }
      } else if (error !== undefined && error.response !== undefined) {
        setMessageAlert(error.response.data)
      } else {
        setMessageAlert("Ocorreu um erro. Entre em contato com o suporte.")
      }
    });
  }

  useEffect(() => {
    if (!firstTriggeredCall) {
      callApiFirstTime();
      window.scrollTo(0, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppThemeLoggedAreationProvider>
      <Box minHeight="680px">
        <Grid container>

          <Grid item xs={12}>
            <Box marginTop={4} marginLeft={1} marginBottom={4}>
              <TmpTypographyCustom component='heading' size='medium' variant='h4' id='texto-nova-solicitacao'>
                Nova solicitação
              </TmpTypographyCustom>
            </Box>
          </Grid>

          {firstTriggeredCall && showButtonCreateRequest ?
            <Grid item xs={12}>
              <TmpButtonCollapseCustom label="Criar uma nova solicitação de recadastramento" icon={<CheckIcon />} handleClick={handleCreateReRegistrationRequest} />
            </Grid>
            : null}

          {firstTriggeredCall && showButtonContinueRequest ?
            <Grid item xs={12}>
              <TmpButtonCollapseCustom label="Continuar o preenchimento da solicitação de recadastramento" icon={<EditIcon />} handleClick={handleCreateReRegistrationRequest} />
            </Grid>
            : null}

          {firstTriggeredCall && !showButtonContinueRequest && !showButtonCreateRequest ?
            <Grid item xs={12}>
              <Box marginLeft={1}>
                <TmpTypographyCustom component='paragraph' size='small' variant='h5' id='texto-nova-solicitacao'>
                  Já existe uma solicitação de recadastramento em análise.
                </TmpTypographyCustom>
              </Box>
            </Grid>
            : null}

          <Grid item xs={12}>
            <Box mt={5}>
              <Divider />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box marginLeft={1} marginTop={4} marginBottom={4} >
              <TmpTypographyCustom component='heading' size='medium' variant='h5' id='texto-solicitacoes-realizadas'>
                Solicitação realizadas
              </TmpTypographyCustom>
            </Box>
          </Grid>

          <Grid item xs={12}>

            {request === undefined || request.length === 0 ?
              <Grid item xs={12} key={`nao-existe-dados`}>
                <Box marginLeft={1}>
                  <TmpTypographyCustom component='paragraph' size='medium' variant='h2' id='texto-mensagem-sem-dados'>
                    Não existe dados para serem apresentados.
                  </TmpTypographyCustom>
                </Box>
              </Grid>
              : null}

            {request !== undefined && request.map((requestItem, index) => (

              <Box marginLeft={5} marginRight={5} marginBottom={3} key={`${index}-solicitacao-cadastrada`}>
                <div style={{ border: "1px solid #E0E0E0", padding: "10px", borderRadius: "8px" }}>
                  <Grid container>
                    <Grid item xs={3}>
                      <div style={{ textAlign: "center", height: "98%", borderRight: "1px solid #E0E0E0" }}>
                        <TmpTypographyCustom component='caption' size='large' variant='h2' id='text-data-criacao-solicitacao'>
                          Data da criação da solicitação
                        </TmpTypographyCustom>
                        <br />
                        <TmpTypographyCustom component='caption' size='large' variant='h2' id='text-hora'>
                          <strong>{requestItem.CreatedDateToFormatted} hrs</strong>
                        </TmpTypographyCustom>
                      </div>

                    </Grid>
                    <Grid item xs={3}>
                      <div style={{ height: "98%", borderRight: "1px solid #E0E0E0" }}>
                        <div style={{ display: "flex", textAlign: "center", alignItems: "center", justifyContent: "center", height: "100%" }}>
                          <div style={{ textAlign: "center" }}>
                            <TmpTypographyCustom component='caption' size='medium' variant='h2' id='texto-situacao' >
                              Situação: <strong style={{ color: requestItem.ColorStatus }}>{requestItem.RequestStateNameToExibition}</strong>
                            </TmpTypographyCustom>
                          </div>
                        </div>
                      </div>
                    </Grid>
                    {requestItem.Protocol !== "" && requestItem.Protocol !== undefined && requestItem.Protocol !== null ?
                      <Grid item xs={3}>
                        <div style={{ height: "98%", borderRight: "1px solid #E0E0E0" }}>
                          <div style={{ display: "flex", textAlign: "center", alignItems: "center", justifyContent: "center", height: "100%" }}>
                            <div style={{ textAlign: "center" }}>
                              <TmpTypographyCustom component='heading' size='small' variant='h2' id='texto-protocolo'>
                                Protocolo: <span style={{ color: "#2C6EF2" }}>{requestItem.Protocol}</span>
                              </TmpTypographyCustom>
                            </div>
                          </div>
                        </div>
                      </Grid>
                      : null}

                    {requestItem.ConclusionDate !== undefined && requestItem.ConclusionDate !== null ?
                      <Grid item xs={3}>
                        <div style={{ textAlign: "center", height: "98%" }}>
                          <TmpTypographyCustom component='caption' size='large' variant='h2' id='text-data-criacao-solicitacao'>
                            Data da Conclusão
                          </TmpTypographyCustom>
                          <br />
                          <TmpTypographyCustom component='caption' size='large' variant='h2' id='text-hora'>
                            <strong>{requestItem.ConclusionDateToFormatted} hrs</strong>
                          </TmpTypographyCustom>
                        </div>

                      </Grid>
                      : null}

                  </Grid>
                </div>
              </Box>
            ))}
          </Grid>

        </Grid>
      </Box>
      <TmpLoadingCustom label="Aguarde, carregando informações da solicitação" loading={isLoading} />
      <TmpAlertCustom isOpened={isOpenAlert} message={messageAlert} title="Atenção" type="error"></TmpAlertCustom>
    </AppThemeLoggedAreationProvider>
  );
}
